<template>
    <section>
        <!-- FORGOT PASSWORD FORM -->
        <div class="forgotPassFormWrapper">
            <v-form
                ref="form"
                v-model="valid"
                class="forgotPassForm d-flex justify-space-around align-center"
                :disabled="recoverPass&&recoverPass.status===200"
                @submit.prevent="validateFunc"
            >
                <v-card class="elevation-5 forgotPassCard" shaped>
                    <v-container>
                        <div class="forgotPass">
                            <img src="../../../assets/newpassword.svg" alt="">
                        </div>
                        <v-card-title>Reset password </v-card-title>
                        <v-divider />
                        <v-alert
                            v-model="error.status"
                            dismissible
                            class="text-center"
                            transition="scale-transition"
                            style="position: absolute; z-index: 2; left: 0; right: 0; top: calc(20% - 10px); margin: 0 10px; border-radius: 16px;"
                            :type="error.color"
                        >
                            {{ error.message }}
                        </v-alert>
                        <v-card-text class="text-center">
                            <div class="txtfieldWrapper">
                                <v-text-field
                                    v-model="newPass"
                                    label="Enter your new password"
                                    color="green accent-4"
                                    :rules="passwordRule"
                                    :append-icon="showPass.new ? mdiEye : mdiEyeOff"
                                    :type="showPass.new ? 'text' : 'password'"
                                    @click:append="showPass.new = !showPass.new"
                                />
                                <v-text-field
                                    v-model="retypedPass"
                                    label="Retype your new password"
                                    color="green accent-4"
                                    :rules="retypePasswordRule.concat([(newPass === retypedPass) || 'Password must match'])"
                                    :append-icon="showPass.retype ? mdiEye : mdiEyeOff"
                                    :type="showPass.retype ? 'text' : 'password'"
                                    @click:append="showPass.retype = !showPass.retype"
                                />
                            </div>

                            <v-btn
                                type="submit"
                                :disabled="!valid || recoverPass&&recoverPass.status===200"
                                small
                                color="green accent-4 white--text"
                                class="my-3"
                                :loading="loading"
                            >
                                <h4>Reset</h4>
                            </v-btn>
                        </v-card-text>
                    </v-container>
                </v-card>
            </v-form>
        </div>

    <!-- END FORGOT PASSWORD FORM -->
    </section>
</template>

  <script>
import { mdiEye, mdiEyeOff } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
export default {
    data: () => ({
        mdiEye, mdiEyeOff,
        loading: false,
        showPass: {
            new: false,
            retype: false
        },
        error: {
            color: '',
            status: false,
            message: ''
        },
        membCodeRule: [(v) => !!v || 'Member Code is required'],
        passwordRule: [
            (v) => !!v || 'Enter your password',
            (v) =>
                // validate the new regex here https://regexr.com/7rr6e
                // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(validation) ||
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()-_=+{};:,.<>?/\\|\[\]~]{8,}$/.test(v) ||
                'Must contain uppercase, lowercase and number and at least 8 characters '
        ],
        retypePasswordRule: [(v) => !!v || 'Retype your password'],
        valid: true,
        newPass: '',
        retypedPass: ''
    }),
    computed: {
        ...mapGetters(['recoverPass'])
    },
    watch: {
        recoverPass(newVal) {
            this.loading = false
            if (newVal && newVal.status === 200) {
                this.error = {
                    color: 'success',
                    message: 'Password Updated Successfully!',
                    status: true
                }
                let timer = 5
                const intervalId = setInterval(() => {
                    this.error = {
                        color: 'success',
                        message: `Redirecting to Login ... (${timer})`,
                        status: true
                    }
                    timer--
                    if (timer === 0) {
                        clearInterval(intervalId)
                        this.$router.push('/')
                    }
                }, 1000)
            } else if (newVal && newVal.status === 403) {
                this.$router.push('/recoveryLinkExpired?exp=0')
            } else {
                this.error = {
                    color: 'error',
                    message: newVal.state,
                    status: true
                }
                setTimeout(()=>{
                    this.error.status = false
                }, 5000)
            }
        }
    },
    methods: {
        ...mapActions(['getCsrfToken','recoverPassword']),
        async validateFunc() {
            this.showPass.new = false
            this.showPass.retype = false
            if (this.$refs.form.validate()) {
                this.loading = true
                await this.recoverPassword({ TOKEN: this.$route.query.tkn, NEW_PASS: this.newPass })
            }
        }
    }
}
  </script>

  <style scoped>
  section {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    background-image: url("../../../assets/loginBG.webp");
    background-position: center;
    background-size: cover;
  }
  .forgotPassFormWrapper {
    width: 100%;
  }
  .displayForgotAccnt {
    display: none;
    width: 100%;
  }
  .forgotPassCard {
    position: relative;
    background-image: url("../../../assets/mail-bg-wrapper.webp");
    background-size: cover;
    background-position: right;
    width: 30%;
  }
  .forgotPass {
    width: 50%;
    margin: auto;
  }
  .forgotPass img {
    width: 100%;
  }
  .txtfieldWrapper {
    width: 100%;
  }
  @media (max-width: 599px) {
    .forgotPassCard {
        position: relative;
        width: 90%;
    }
  }
  </style>
